import { useRoutes } from "react-router-dom";
import Pages from "./Pages";

function RoleRoutes() {
  const router = useRoutes([Pages()]);
  return router;
}

export default RoleRoutes;
